import React from 'react';

const RetryIcon = (props: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.964 3.10962C7.71015 2.85578 7.71015 2.44422 7.964 2.19038C8.21784 1.93654 8.62939 1.93654 8.88323 2.19038L10.6732 3.98031C10.927 4.23415 10.927 4.6457 10.6732 4.89955L8.88323 6.68947C8.62939 6.94331 8.21784 6.94331 7.964 6.68947C7.71015 6.43563 7.71015 6.02407 7.964 5.77023L8.64427 5.08996H8.12518C6.01288 5.08996 4.30037 6.80247 4.30037 8.91478C4.30037 11.0271 6.01288 12.7396 8.12518 12.7396C10.2375 12.7396 11.95 11.0271 11.95 8.91478C11.95 8.28124 11.7964 7.68537 11.5251 7.16106C11.3601 6.84223 11.4848 6.45003 11.8037 6.28504C12.1225 6.12006 12.5147 6.24477 12.6797 6.5636C13.0444 7.26837 13.25 8.06864 13.25 8.91478C13.25 11.7451 10.9555 14.0396 8.12518 14.0396C5.29491 14.0396 3.00037 11.7451 3.00037 8.91478C3.00037 6.0845 5.29491 3.78996 8.12518 3.78996H8.64434L7.964 3.10962Z"
      fill="#EB274B"
    />
  </svg>
);

export default RetryIcon;
